import {
  InvoiceLineItemType,
  TransactionProvider,
  TransactionType,
} from '@principle-theorem/principle-core/interfaces';
import { Timestamp } from '@principle-theorem/shared';

export interface IInvoiceAllocationTestCaseLineItem {
  type: InvoiceLineItemType;
  amount: number;
  quantity?: number;
  allocatedTo?: string; // DocumentReference<IStaffer>;
}

export interface IInvoiceAllocationTestCaseTransaction {
  transactionRef: string; // DocumentReference<ITransaction>;
  provider: TransactionProvider;
  type: TransactionType;
  createdAt: Timestamp;
  amount: number;
  allocatedTo?: string; // DocumentReference<IStaffer>;
}

export interface ICurrentTransactionAllocation {
  allocatedTo: string; // TransactionAllocationTarget;
  allocatedProportion: number;
  allocatedAmount: number;
}

export interface ICurrentTransactionAllocations {
  transactionRef: string; // DocumentReference<ITransaction>;
  allocations: ICurrentTransactionAllocation[];
}

export interface IInvoiceAllocationTestCase {
  invoiceRef: string; // DocumentReference<IInvoice>;
  invoiceItems: IInvoiceAllocationTestCaseLineItem[];
  transactions: IInvoiceAllocationTestCaseTransaction[];
  currentTransactionAllocations: ICurrentTransactionAllocations[];
}
